import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import CustomTypography from '../../../../components/Typography/CustomTypography';
import { GetZonesStatusRequested } from '../../../../actions/CommonOptions';
import SolidInput from './SolidInput';

const MAX_FIELD_LENGTH = 20;
const ZONE_LIMIT = 5;

const EventZone = ({
    classes,
    params,
    handleSetParams,
    validateResults,
    editMode,
    eventZones,
    fetchZonesStatus,
    zonesStatus,
}) => {
    const [protectedZones, setProtectedZones] = useState({});
    const intl = useIntl();

    const isProtectedZone = (zoneId) => zoneId && Object.keys(protectedZones).includes(zoneId.toString());

    const handleDeleteField = (key) => {
        if (editMode && isProtectedZone(params.zones[key].id)) {
            setProtectedZones({
                ...protectedZones,
                [`${params.zones[key].id}`]: {
                    message: 'danger',
                },
            });

            return;
        }

        handleSetParams('zones', params.zones.filter((item, index) => index !== key));
    };

    const handleAddField = () => {
        const currentZone = params.zones;

        if (currentZone.length < ZONE_LIMIT) {
            currentZone.push({ id: null, zone_name: '' });
            handleSetParams('zones', currentZone);
        }
    };

    const handleChangeField = (value, key) => {
        if (editMode && isProtectedZone(params.zones[key].id)) {
            setProtectedZones({
                ...protectedZones,
                [`${params.zones[key].id}`]: {
                    message: 'warning',
                },
            });
        }

        handleSetParams('zones', params.zones.map((item, index) => (index === key ? { ...item, zone_name: value } : item)));
    };

    const isDisplayZoneError = (message = '', zones) => {
        if (!message) return false;

        if (message === 'validation.required') {
            return zones.some((item) => _.isEmpty(item.zone_name.trim()));
        }

        if (message === 'validation.unique') {
            const filterZone = zones.map((item) => item.zone_name);

            const haveDuplicatesValue = filterZone.some(
                (val, i) => filterZone.indexOf(val) !== i,
            );

            return haveDuplicatesValue;
        }

        return false;
    };

    useEffect(() => {
        if (editMode && _.isArray(eventZones) && eventZones.length > 0) {
            handleSetParams('zones', eventZones.map((item) => ({ id: item.id, zone_name: item.name })));
            fetchZonesStatus(eventZones.map((item) => item.id).join(','));
        }
    }, [editMode, eventZones, fetchZonesStatus]);

    useEffect(() => {
        if (!_.isEmpty(zonesStatus)) {
            const registeredZones = {};

            for (const property in zonesStatus) {
                if (zonesStatus[property]) {
                    registeredZones[property] = {
                        message: '',
                    };
                }
            }

            setProtectedZones(registeredZones);
        }
    }, [editMode, zonesStatus]);

    return (
        <>
            <div className={classes.leftTitle}>
                <CustomTypography bold>
                    {intl.formatMessage({ id: 'zone' })}
                </CustomTypography>
            </div>

            <div className={classes.rightInput} style={{ marginBottom: '15px' }}>
                {params?.zones && params.zones.map((zone, index) => (
                    <div key={index}>
                        <SolidInput
                            className={classes.right}
                            defaultValue={zone.zone_name}
                            onChange={(value) => handleChangeField(value, index)}
                            handleAddField={handleAddField}
                            handleDeleteField={() => handleDeleteField(index)}
                            inputProps={{
                                maxLength: MAX_FIELD_LENGTH,
                            }}
                            addable={params.zones.length < ZONE_LIMIT && index === 0}
                            deleteable={params.zones.length > 1}
                            isFirst={index === 0}
                        />

                        {(zone.id && protectedZones[`${zone.id}`]?.message) && (
                            <CustomTypography
                                color={protectedZones[`${zone.id}`].message}
                                style={{ fontSize: '0.75rem', margin: '-10px 0 15px 15px' }}
                            >
                                {intl.formatMessage({ id: `zone.${protectedZones[`${zone.id}`].message}` })}
                            </CustomTypography>
                        )}
                    </div>
                ))}

                {(validateResults?.zones && isDisplayZoneError(validateResults?.zones.message, params.zones)) && (
                    <CustomTypography
                        color="danger"
                        style={{ fontSize: '0.75rem', marginLeft: '15px', marginBottom: '15px' }}
                    >
                        {intl.formatMessage({ id: validateResults?.zones.message })}
                    </CustomTypography>
                )}
            </div>
        </>
    );
};

const mapStateToProps = (state, ownProps) => ({
    classes: ownProps.classes,
    params: ownProps.params,
    handleSetParams: ownProps.handleSetParams,
    validateResults: ownProps.validateResults,
    editMode: ownProps.eventId > 0,
    eventZones: state.commonOptions.zones.data,
    zonesStatus: state.commonOptions.zonesStatus.data.registered_status,
});

const mapDispatchToProps = (dispatch) => ({
    fetchZonesStatus: (params) => {
        dispatch(GetZonesStatusRequested(params));
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(EventZone);

EventZone.propTypes = {
    classes: PropTypes.oneOfType([() => null, PropTypes.object]).isRequired,
    params: PropTypes.oneOfType([() => null, PropTypes.object]).isRequired,
    handleSetParams: PropTypes.func.isRequired,
    validateResults: PropTypes.oneOfType([() => null, PropTypes.object]).isRequired,
    editMode: PropTypes.bool.isRequired,
    eventZones: PropTypes.oneOfType([null, PropTypes.array]).isRequired,
    fetchZonesStatus: PropTypes.func.isRequired,
    zonesStatus: PropTypes.oneOfType([null, PropTypes.array]).isRequired,
};
